import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@material-ui/core';
import api from 'services/api';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';

const CHAVE_CACHE = 'dicionarioDadosFornecedor';

const ESTILO_CELULA = {
    padding: '6px 16px'
};

class DicionarioDadosFornecedor extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        dadosDicionario: []
    };

    /* Carrega os dados iniciais da tela */
    componentDidMount() {
        this._isMounted = true;
        this.loadDicionario();
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Carrega o dicionário (usa o cache do sessionStorage quando existir) */
    loadDicionario = async () => {
        try {
            const dicionarioCache = sessionStorage.getItem(CHAVE_CACHE);

            if (dicionarioCache !== null) {
                this.safeSetState({ dadosDicionario: JSON.parse(dicionarioCache) });

                return;
            }

            const response = await api.get('/whatsapp/dicionariofornecedor');

            sessionStorage.setItem(CHAVE_CACHE, JSON.stringify(response.data));

            this.safeSetState({ dadosDicionario: response.data });
        } catch (error) {
            console.error('Erro ao carregar o dicionário de dados:', error);

            // descarta o cache inválido para recarregar da API na próxima vez
            sessionStorage.removeItem(CHAVE_CACHE);
        }
    };

    render() {
        const { dadosDicionario } = this.state;

        return (
            <div>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell style={ESTILO_CELULA}>
                                    <strong>Campo</strong>
                                </TableCell>

                                <TableCell style={ESTILO_CELULA}>
                                    <strong>Descrição</strong>
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {dadosDicionario.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell style={ESTILO_CELULA}>
                                        {item.campo}
                                    </TableCell>

                                    <TableCell style={ESTILO_CELULA}>
                                        {item.descricao}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
};

export default DicionarioDadosFornecedor;